<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Detalhes do estoque</h2>
    <p class="modal-subtitle">{{ subtitulo }}</p>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar"
      (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content estoque-dialog-content">
  <mat-tab-group appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true">

    <!-- ================= Estoque ================= -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">inventory_2</mat-icon>
        <span class="tab-label-text">Estoque</span>
      </ng-template>

      <div class="aba-conteudo">
        @if (carregandoEstoque) {
          <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
          <!-- Uma linha por localização; é o que o `produtoSaldoLocal` sabe responder. -->
          @if (locais.length) {
            <div class="table-container desktop-view">
              <table mat-table [dataSource]="locais" class="w-100">
                <ng-container matColumnDef="localizacao">
                  <th mat-header-cell *matHeaderCellDef>Localização</th>
                  <td mat-cell *matCellDef="let l">{{ l.localizacao || l.codigoLocalizacao || 'Sem localização' }}</td>
                  <td mat-footer-cell *matFooterCellDef class="fw-semibold">Todos</td>
                </ng-container>

                <ng-container matColumnDef="fisico">
                  <th mat-header-cell *matHeaderCellDef class="text-end">Físico</th>
                  <td mat-cell *matCellDef="let l" class="text-end">{{ l.saldoFisico | abnt: 'quantidade' }}</td>
                  <td mat-footer-cell *matFooterCellDef class="text-end fw-semibold">{{ totalFisico | abnt: 'quantidade' }}</td>
                </ng-container>

                <ng-container matColumnDef="reservado">
                  <th mat-header-cell *matHeaderCellDef class="text-end">Reservado</th>
                  <td mat-cell *matCellDef="let l" class="text-end">{{ l.saldoReservado | abnt: 'quantidade' }}</td>
                  <td mat-footer-cell *matFooterCellDef class="text-end fw-semibold">{{ totalReservado | abnt: 'quantidade' }}</td>
                </ng-container>

                <ng-container matColumnDef="disponivel">
                  <th mat-header-cell *matHeaderCellDef class="text-end">Disponível</th>
                  <td mat-cell *matCellDef="let l" class="text-end">{{ l.saldoDisponivel | abnt: 'quantidade' }}</td>
                  <td mat-footer-cell *matFooterCellDef class="text-end fw-semibold">{{ totalDisponivel | abnt: 'quantidade' }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="colunasEstoque"></tr>
                <tr mat-row *matRowDef="let l; columns: colunasEstoque;"></tr>
                <tr mat-footer-row *matFooterRowDef="colunasEstoque"></tr>
              </table>
            </div>

            <div class="mobile-view">
              @for (l of locais; track l.idLocalizacaoEstoque) {
                <div class="card-mobile mb-3">
                  <div class="card-header-mobile">
                    <span class="fw-semibold">{{ l.localizacao || l.codigoLocalizacao || 'Sem localização' }}</span>
                  </div>
                  <div class="card-body-mobile p-3">
                    <p class="mb-2"><strong>Físico:</strong> {{ l.saldoFisico | abnt: 'quantidade' }}</p>
                    <p class="mb-2"><strong>Reservado:</strong> {{ l.saldoReservado | abnt: 'quantidade' }}</p>
                    <p class="mb-0"><strong>Disponível:</strong> {{ l.saldoDisponivel | abnt: 'quantidade' }}</p>
                  </div>
                </div>
              }

              <div class="card-mobile mb-3">
                <div class="card-header-mobile">
                  <span class="fw-semibold">Todos</span>
                </div>
                <div class="card-body-mobile p-3">
                  <p class="mb-2"><strong>Físico:</strong> {{ totalFisico | abnt: 'quantidade' }}</p>
                  <p class="mb-2"><strong>Reservado:</strong> {{ totalReservado | abnt: 'quantidade' }}</p>
                  <p class="mb-0"><strong>Disponível:</strong> {{ totalDisponivel | abnt: 'quantidade' }}</p>
                </div>
              </div>
            </div>
          } @else {
            <app-empty-state icon="inventory_2"
              title="Este produto não tem saldo em nenhuma localização.">
            </app-empty-state>
          }

          <!-- Rótulo/valor da §6.3, com o que só faz sentido consolidado. -->
          <div class="resumo-estoque">
            <div>
              <div class="small text-muted">Estoque mínimo</div>
              <div>{{ estoqueMinimo === null ? '—' : (estoqueMinimo | abnt: 'quantidade') }}</div>
            </div>
            <div>
              <div class="small text-muted">Estoque máximo</div>
              <div>{{ estoqueMaximo === null ? '—' : (estoqueMaximo | abnt: 'quantidade') }}</div>
            </div>
            <div>
              <div class="small text-muted">
                Quantidade neste documento
                @if (data.siglaUnidade) { ({{ data.siglaUnidade }}) }
              </div>
              <div>{{ data.quantidade | abnt: 'quantidade' }}</div>
            </div>
            <div>
              <div class="small text-muted">Estoque depois da venda</div>
              <div class="fw-semibold" [class.text-danger]="faltaEstoque">
                {{ estoqueDepoisDaVenda | abnt: 'quantidade' }}
              </div>
            </div>
          </div>

          @if (faltaEstoque) {
            <!-- Aviso, nunca bloqueio: quem barra o salvamento é a configuração do processo. -->
            <app-alert-card type="warning" title="Estoque insuficiente" class="d-block mt-3">
              A quantidade lançada não cabe no disponível. O documento ainda pode ser gravado — o
              bloqueio, se houver, é o da configuração do processo.
            </app-alert-card>
          }

          @if (estoqueMinimo === null && estoqueMaximo === null) {
            <p class="small text-muted mt-3 mb-0">
              Mínimo e máximo são cadastrados por localização em Suprimentos; nenhuma localização
              deste produto tem reposição configurada.
            </p>
          }
        }
      </div>
    </mat-tab>

    <!-- ================= Últimas vendas ================= -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">receipt_long</mat-icon>
        <span class="tab-label-text">Últimas vendas</span>
      </ng-template>

      <div class="aba-conteudo">
        <p class="small text-muted mb-3">Últimas vendas deste produto para este cliente.</p>

        @if (carregandoVendas) {
          <app-loading-box-default-list></app-loading-box-default-list>
        } @else if (semCliente) {
          <app-empty-state icon="person_search"
            title="Escolha o cliente do documento para ver o histórico deste produto.">
          </app-empty-state>
        } @else if (!vendas.length) {
          <app-empty-state icon="receipt_long"
            title="Não existem vendas desse produto para este cliente.">
          </app-empty-state>
        } @else {
          <div class="table-container desktop-view">
            <table mat-table [dataSource]="vendas" class="w-100">
              <ng-container matColumnDef="documento">
                <th mat-header-cell *matHeaderCellDef>Documento</th>
                <td mat-cell *matCellDef="let v" class="fw-semibold">Nº {{ v.numero }}</td>
              </ng-container>

              <ng-container matColumnDef="data">
                <th mat-header-cell *matHeaderCellDef>Data</th>
                <td mat-cell *matCellDef="let v">{{ v.dataEmissao | date: 'dd/MM/yyyy' }}</td>
              </ng-container>

              <ng-container matColumnDef="etapa">
                <th mat-header-cell *matHeaderCellDef>Etapa</th>
                <td mat-cell *matCellDef="let v">
                  @if (v.nomeEtapaKanban) {
                    <span class="status-badge" [style.background]="corDaEtapa(v).fundo"
                      [style.color]="corDaEtapa(v).conteudo">{{ v.nomeEtapaKanban }}</span>
                  } @else { — }
                </td>
              </ng-container>

              <ng-container matColumnDef="quantidade">
                <th mat-header-cell *matHeaderCellDef class="text-end">Qtde</th>
                <td mat-cell *matCellDef="let v" class="text-end">{{ v.quantidade | abnt: 'quantidade' }}{{ v.siglaUnidade ? ' ' + v.siglaUnidade : '' }}</td>
              </ng-container>

              <ng-container matColumnDef="valorUnitario">
                <th mat-header-cell *matHeaderCellDef class="text-end">Preço un.</th>
                <td mat-cell *matCellDef="let v" class="text-end">{{ v.valorUnitario | abnt: 'preco' }}</td>
              </ng-container>

              <ng-container matColumnDef="valorTotal">
                <th mat-header-cell *matHeaderCellDef class="text-end">Total</th>
                <td mat-cell *matCellDef="let v" class="text-end">{{ v.valorTotal | abnt: 'preco' : 2 }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="colunasVendas"></tr>
              <tr mat-row *matRowDef="let v; columns: colunasVendas;"></tr>
            </table>
          </div>

          <div class="mobile-view">
            @for (v of vendas; track v.idVenda) {
              <div class="card-mobile mb-3">
                <div class="card-header-mobile">
                  <span class="fw-semibold">Nº {{ v.numero }}</span>
                </div>
                <div class="card-body-mobile p-3">
                  <p class="mb-2"><strong>Data:</strong> {{ v.dataEmissao | date: 'dd/MM/yyyy' }}</p>
                  <p class="mb-2">
                    <strong>Etapa:</strong>
                    @if (v.nomeEtapaKanban) {
                      <span class="status-badge ms-1" [style.background]="corDaEtapa(v).fundo"
                        [style.color]="corDaEtapa(v).conteudo">{{ v.nomeEtapaKanban }}</span>
                    } @else { — }
                  </p>
                  <p class="mb-2">
                    <strong>Qtde:</strong>
                    {{ v.quantidade | abnt: 'quantidade' }}{{ v.siglaUnidade ? ' ' + v.siglaUnidade : '' }}
                  </p>
                  <p class="mb-2"><strong>Preço un.:</strong> {{ v.valorUnitario | abnt: 'preco' }}</p>
                  <p class="mb-0"><strong>Total:</strong> {{ v.valorTotal | abnt: 'preco' : 2 }}</p>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </mat-tab>

    <!-- ================= Compras previstas ================= -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">shopping_cart</mat-icon>
        <span class="tab-label-text">Compras previstas</span>
      </ng-template>

      <div class="aba-conteudo">
        <p class="small text-muted mb-3">Compras em andamento que contêm este produto.</p>

        @if (carregandoCompras) {
          <app-loading-box-default-list></app-loading-box-default-list>
        } @else if (!compras.length) {
          <app-empty-state icon="shopping_cart"
            title="Não existem compras em andamento para este produto.">
          </app-empty-state>
        } @else {
          <div class="table-container desktop-view">
            <table mat-table [dataSource]="compras" class="w-100">
              <ng-container matColumnDef="solicitacao">
                <th mat-header-cell *matHeaderCellDef>Solicitação</th>
                <td mat-cell *matCellDef="let c">
                  <div class="fw-semibold">{{ c.codigo || ('#' + c.idCompra) }}</div>
                  @if (c.titulo) { <div class="small text-muted">{{ c.titulo }}</div> }
                </td>
              </ng-container>

              <ng-container matColumnDef="estagio">
                <th mat-header-cell *matHeaderCellDef>Estágio</th>
                <td mat-cell *matCellDef="let c">
                  @if (c.nomeEtapa) {
                    <!-- A cor do kanban de COMPRAS é hexadecimal na origem, diferente do de
                         vendas, que usa catálogo. Vai só na borda para não brigar com o tema. -->
                    <span class="status-badge badge-cinza etapa-compra"
                      [style.border-color]="c.corEtapa || 'transparent'">{{ c.nomeEtapa }}</span>
                  } @else { — }
                </td>
              </ng-container>

              <ng-container matColumnDef="quantidade">
                <th mat-header-cell *matHeaderCellDef class="text-end">Qtde</th>
                <td mat-cell *matCellDef="let c" class="text-end">{{ c.quantidade | abnt: 'quantidade' }}{{ c.unidade ? ' ' + c.unidade : '' }}</td>
              </ng-container>

              <ng-container matColumnDef="previsao">
                <th mat-header-cell *matHeaderCellDef>Previsão</th>
                <td mat-cell *matCellDef="let c">{{ previsaoDe(c) }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="colunasCompras"></tr>
              <tr mat-row *matRowDef="let c; columns: colunasCompras;"></tr>
            </table>
          </div>

          <div class="mobile-view">
            @for (c of compras; track c.idCompra) {
              <div class="card-mobile mb-3">
                <div class="card-header-mobile">
                  <div class="fw-semibold">{{ c.codigo || ('#' + c.idCompra) }}</div>
                  @if (c.titulo) { <div class="small text-muted">{{ c.titulo }}</div> }
                </div>
                <div class="card-body-mobile p-3">
                  <p class="mb-2">
                    <strong>Estágio:</strong>
                    @if (c.nomeEtapa) {
                      <span class="status-badge badge-cinza etapa-compra ms-1"
                        [style.border-color]="c.corEtapa || 'transparent'">{{ c.nomeEtapa }}</span>
                    } @else { — }
                  </p>
                  <p class="mb-2">
                    <strong>Qtde:</strong>
                    {{ c.quantidade | abnt: 'quantidade' }}{{ c.unidade ? ' ' + c.unidade : '' }}
                  </p>
                  <p class="mb-0"><strong>Previsão:</strong> {{ previsaoDe(c) }}</p>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
